import '../../utils/index.mjs';
import _sfc_main from './src/badge2.mjs';
export { badgeProps } from './src/badge.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElBadge = withInstall(_sfc_main);

export { ElBadge, ElBadge as default };
//# sourceMappingURL=index.mjs.map
